import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PregledIzdatniceTrosakService {
  constructor(private _http: HttpClient) {}

  dohvatiIzdatniceTrosak(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_izdatnice_trosak', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuIzdatnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jednu_izdatnicu', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeDodaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeDodaj', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeUredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeUredi', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaTrosakZavrsi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'izdatnica_trosak_zavrsi', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaTrosakObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'izdatnica_trosak_obrisi', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeObrisi', a)
      .pipe(map((res: any) => res));
  }

  artiklPopisZaPoslovnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'artiklPopisZaPoslovnicu', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaTrosakStorno(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izdatnica_trosak_storno', a)
      .pipe(map((res: any) => res));
  }

  poslovnicaPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }
  
  izdatnicaTrosakDodaj(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izdatnica_trosak_dodaj', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaTrosakUredi(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izdatnica_trosak_uredi', a)
      .pipe(map((res: any) => res));
  }
}
